module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.noForm) ? _c('span', [_vm._v(_vm._s(_vm.label) + " ")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "value-key": "value",
      "size": _vm.size
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, _vm._l((_vm.contacts), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4662a5a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectContact.vue
// module id = 1537
// module chunks = 0